module.exports = __webpack_public_path__ + "static/media/YB5F07_2.39d3fd3b.jpg";